export default class ResponseType {
    constructor(public id: number, public label: string, public template: string, public code: string, public className: string = '') {
    }
}
